module.exports = __webpack_public_path__ + "static/media/52633974_2452968281445015_2207410128385212416_o.48b53b68.jpg";